import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import 'firebase/firestore';
import * as firebase from 'firebase/app';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { SessionService } from 'app/sessions/session.service';
@Injectable()
export class UserService {
    list : AngularFireList<any>;
    constructor(public af: AngularFireAuth, private db: AngularFireDatabase, private ss:SessionService) {
    }
        //to get all users
        public getAllUser()
        {
            this.list = this.db.list("users");
            return this.list;
        }
        //to get all branches
        public getAllBranches(){
            this.list = this.db.list("branches");
            return this.list;
        }

        checkUserExists(username)
            {
            this.list = this.db.list('users',ref => ref.orderByChild('userName').equalTo(username));
            return this.list;
            }
            checkUserExistsInDb(username)
            {
            return firebase.database().ref("users").orderByChild("userName").equalTo(username);
            }
            checkPhoneNumberExists(phoneNumber)
            {
                return  firebase.database().ref("users").orderByChild("phoneNumber").equalTo(phoneNumber);
            }

            createUser(email,password)
            {
                return this.af.auth.createUserWithEmailAndPassword(email,password);
            }

            getCurrentUser()
            {
                return this.af.auth.currentUser.uid;
            }
            getUser(uid)
            {
                return  firebase.database().ref("users").child(uid);
            }
            getEmployeeDetails(eid)
            {
                return  firebase.database().ref("users").orderByChild("employeeId").equalTo(eid);
            }
            getUserOfDepartment(department)
            {
                return firebase.database().ref("users").orderByChild("department").equalTo(department);
            }
            getLastEmployeeId()
            {
                return firebase.database().ref("users").orderByChild("employeeId").limitToLast(1);
            }
            updatePhotoUrl(url,uid,path)
            {
                return firebase.database().ref("users").child(uid).child(path).set(url);
            }
            updateUser(uid,data)
            {
                return firebase.database().ref("users").child(uid).update(data);
            }
            getUserDesignation()
            {
                return firebase.database().ref("users").child(this.ss.getUserId).child("designation");
            }
            getAllDrivers()
            {
            return this.db.list("users", ref=>ref.orderByChild("role").equalTo("driver"));
            }
            getAllSupervisors()
            {
            return this.db.list("users", ref=>ref.orderByChild("role").equalTo("supervisor"));
            }
            getAllEmployees()
            {
                return this.db.list("users", ref=>ref.orderByChild("role").equalTo("employee"));
            }
            getSeachedUser()
            {
                return this.db.list("users", ref=>ref.orderByChild("employeeId").equalTo("supervisor"));
            }
            deleteEmployee(uid)
            {
                return firebase.database().ref("users").child(uid).remove();
                /* var data = {
                    boardingStatus: "offboard",
                    status: "0"
                }
                return firebase.database().ref("users").child(uid).update(data); */
            }
            updateDeleteEmployeeToDeleteInAuth(uid)
            {
                return firebase.database().ref("deleteUser").child(uid).set("delete");
            }
            updateStatus(uid,status)
            {
                return firebase.database().ref("users").child(uid).child("status").set(status);
            }
            getAllUsersOfBranch(branch)
            {
                return firebase.database().ref("users").orderByChild("branch").equalTo(branch);
            }
        }


// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/users/shared/user.service.ts